import React from 'react'

import { Outlet } from 'react-router';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

const Layout = () => {
    
   
  return (
   
    <Sidebar>
      <Outlet />
    </Sidebar>
  )
}

export default Layout